<div *accessRoles="VIEW_REPORT">
  <ng-container *ngIf="isVATRegistered === true">
    <div class="row vat-notice">
      <div class="container">
        <span>You have told us that you are VAT registered, you may need to send us an invoice for the commission you
          receive.
          <br>Please click
          <a class="hyper-link" (click)="downloadTemplate()">here</a> for further information.</span>
        <i class="material-icons icon-white ml-auto" (click)="closeVATNotice()"> close </i>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isVATRegistered === false">
    <div class="row vat-notice">
      <div class="container">
        <span>You have told us you are not VAT registered, if this has changed, please update your records with
          us.</span>
        <i class="material-icons icon-white ml-auto" (click)="closeVATNotice()"> close </i>
      </div>
    </div>
  </ng-container>

  <div class="commission-container">
    <div class="container col-12">
      <div class="row">
        <div class="col-2 text-right ml-auto">
          <button class="btn btn-block btn-greengo btn-lg" (click)="downloadCommissionPDF()" npFocusOutClicked>Download to PDF</button>
        </div>
        <div class="col-2 text-right">
          <button class="btn btn-block btn-greengo btn-lg" (click)="downloadCommissionExcel()" npFocusOutClicked>Download to Excel</button>
        </div>
      </div>
      <div class="header--wrapper row">
        <div class="col-6 main-header-left">
          <div class="row no-gutters">
            <div class="left-panel col-3">
              Partner name
            </div>
            <div class="right-panel col-9">
              {{commissionInfo?.partnerName}}
            </div>
          </div>
          <div class="row no-gutters">
            <div class="left-panel col-3">
              Partner code
            </div>
            <div class="right-panel col-9">
              {{commissionInfo?.partnerCode}}
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="input--border">{{commissionInfo?.month}} {{commissionInfo?.year}} Commission Report</div>
            </div>
          </div>
        </div>
        <div class="col-6 main-header-right">
          <div class="row">
            <div class="left-panel col-6">
              <ul class="list-unstyled">
                <li>
                  {{brandName}} Limited
                </li>
                <li>
                  16 Eastcheap
                </li>
                <li>
                  London
                </li>
                <li>
                  EC3M 1BD
                </li>
                <li>
                  United Kingdom
                </li>
                <li>
                  &nbsp;
                </li>
                <li>
                  Call: {{phone}}
                </li>
                <li>
                  Email: accounts@{{domain}}
                </li>
              </ul>
            </div>
            <div class="right-panel col-6 text-right">
              <a href="https://www.{{domain}}/" class="ml-auto">
                <img class="img-fluid" *imageWithBrandPrefix="'/assets/images/Application_Form_Logo.png'" width="300" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="table-info--wrapper col-12">
          <div class="row">
            <div class="col-3 mb-4">
              <div class="input--border">
                Trades payable this month
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <table>
                <thead>
                  <th>
                    Client name
                  </th>
                  <th>
                    Trade number
                  </th>
                  <th>
                    Trade type
                  </th>
                  <th>
                    Verified date
                  </th>
                  <th>
                    Value date
                  </th>
                  <th>
                    Payment month
                  </th>
                  <th>
                    Profit currency
                  </th>
                  <th>
                    Profit
                  </th>
                  <th>
                    Partner commission rate
                  </th>
                  <th>
                    Partner commission
                  </th>
                  <th>
                    Partner commission GBP
                  </th>
                  <th>
                    Referred by
                  </th>
                  <th>
                    Deferral info
                  </th>
                </thead>
                <tbody>
                  <tr *ngFor="let commissionMonthItem of commissionMonth">
                    <td>{{commissionMonthItem?.clientName}}</td>
                    <td>{{commissionMonthItem?.tradeNumber}}</td>
                    <td>{{commissionMonthItem?.tradeType}}</td>
                    <td>{{commissionMonthItem?.verifiedDate | date : 'dd/MM/yyyy'}}</td>
                    <td>{{commissionMonthItem?.valueDate | date : 'dd/MM/yyyy'}}</td>
                    <td>{{commissionMonthItem?.expectedPaymentMonth | date : 'MM/yyyy'}}</td>
                    <td>{{commissionMonthItem?.profitCurrency}}</td>
                    <td class="text-right">{{commissionMonthItem?.profit | transformNumber}}</td>
                    <td class="text-right">{{commissionMonthItem?.partnerCommissionRate}}%</td>
                    <td class="text-right">{{commissionMonthItem?.partnerCommission | transformNumber}}</td>
                    <td class="text-right">{{commissionMonthItem?.partnerCommissionGBP | transformNumber}}</td>
                    <td>{{commissionMonthItem?.referredBy}}</td>
                    <td>{{commissionMonthItem?.deferralInfo}}</td>
                  </tr>
                  <tr class="tableSummary">
                    <td colspan="10" class="text-right">Total payable in GBP</td>
                    <td class="text-right">{{totalCommissionMonth | transformNumber}}</td>
                    <td colspan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="table-info--wrapper col-12">
          <div class="row">
            <div class="col-3 mb-4">
              <div class="input--border">
                Trades payable in the future
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <table>
                <thead>
                  <th>
                    Client name
                  </th>
                  <th>
                    Trade number
                  </th>
                  <th>
                    Trade type
                  </th>
                  <th>
                    Verified date
                  </th>
                  <th>
                    Value date
                  </th>
                  <th>
                    Expected payment month
                  </th>
                  <th>
                    Profit currency
                  </th>
                  <th>
                    Profit
                  </th>
                  <th>
                    Partner commission rate
                  </th>
                  <th>
                    Partner commission
                  </th>
                  <th>
                    Partner commission GBP
                  </th>
                  <th>
                    Referred by
                  </th>
                  <th>
                    Deferral info
                  </th>
                </thead>
                <tbody>
                  <tr *ngFor="let commissionMonthItem of commissionFuture">
                    <td>{{commissionMonthItem?.clientName}}</td>
                    <td>{{commissionMonthItem?.tradeNumber}}</td>
                    <td>{{commissionMonthItem?.tradeType}}</td>
                    <td>{{commissionMonthItem?.verifiedDate | date : 'dd/MM/yyyy'}}</td>
                    <td>{{commissionMonthItem?.valueDate | date : 'dd/MM/yyyy'}}</td>
                    <td>{{commissionMonthItem?.expectedPaymentMonth | date : 'MM/yyyy'}}</td>
                    <td>{{commissionMonthItem?.profitCurrency}}</td>
                    <td class="text-right">{{commissionMonthItem?.profit | transformNumber}}</td>
                    <td class="text-right">{{commissionMonthItem?.partnerCommissionRate}}%</td>
                    <td class="text-right">{{commissionMonthItem?.partnerCommission | transformNumber}}</td>
                    <td class="text-right">{{commissionMonthItem?.partnerCommissionGBP | transformNumber}}</td>
                    <td>{{commissionMonthItem?.referredBy}}</td>
                    <td>{{commissionMonthItem?.deferralInfo}}</td>
                  </tr>
                  <tr class="tableSummary">
                    <td colspan="10" class="text-right">Estimated future commission in GBP</td>
                    <td class="text-right">{{totalCommissionFuture | transformNumber}}</td>
                    <td colspan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-7">
              <ul class="list-unstyled text-left" style="margin-top: 10px;font-size: 1.3rem;">
                <li>
                  1. Commission will be paid to you in GBP by the 10th of the next month.
                </li>
                <li>
                  2. Please note that if a trade is modified, the expected payment month may change.
                </li>
                <li>
                  3. The estimated commission is based on the current spot rate.
                </li>
                <li>
                  4. Commission becomes payable on the latest value date of the individual trade, and linked trades.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="footer float-center" align="center">
        <span>
          {{brandName}} Limited is a company registered in England under registration number 11219580
        </span>
        <span>
          Registered office: 16 Eastcheap 5th and 6th Floor, London EC3M 1BD United Kingdom
        </span>
        <span>
          {{brandName}} Limited is authorised by the Financial Conduct Authority as an Electronic Money Institution.
          Reference number: 900887
        </span>
      </div>
    </div>
  </div>
</div>
